import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export type PopoverArrowPosition =
  | 'top-right'
  | 'top-left'
  | 'right-top'
  | 'right-center'
  | 'none';

export const PopoverContainer = styled(motion.div)<{
  $position: PopoverArrowPosition;
}>`
  position: relative;
  color: ${({ theme }) => theme.appUI.fontColor.DEFAULT};
  background: ${({ theme }) => theme.appUI.backgroundColor.DEFAULT};
  min-width: 0;

  background: white;
  box-shadow: -1px 0px 0px rgba(2, 2, 27, 0.07),
    1px 0px 0px rgba(2, 2, 27, 0.07), 0px -1px 0px rgba(2, 2, 27, 0.07),
    0px 1px 0px rgba(2, 2, 27, 0.07), 0px 54px 74px rgba(1, 1, 27, 0.3),
    0px 14px 74px rgba(0, 0, 0, 0.25);
  border-radius: 4px;

  &::after {
    content: '';
    display: block;
    position: absolute;

    height: 12px;
    width: 12px;
    background: ${({ theme }) => theme.appUI.backgroundColor.DEFAULT};
    border-radius: 2px;

    ${({ $position }) =>
      $position === 'right-top' &&
      css`
        right: 0;
        top: 0;
        transform: translate(40%, 50%) rotate(45deg);
      `}

    ${({ $position }) =>
      $position === 'top-right' &&
      css`
        right: 15px;
        top: 0;
        transform: translate(-40%, -50%) rotate(45deg);
      `}

      ${({ $position }) =>
      $position === 'top-left' &&
      css`
        left: 15px;
        top: 0;
        transform: translate(-40%, -50%) rotate(45deg);
      `}

      ${({ $position }) =>
      $position === 'right-center' &&
      css`
        right: 0;
        top: calc(50% - 12px);
        transform: translate(40%, 50%) rotate(45deg);
      `}

      ${({ $position }) =>
      $position === 'none' &&
      css`
        display: none;
      `}
  }
`;
